import {createSlice, PayloadAction} from '@reduxjs/toolkit'
import {initialState} from '@/store/states/prices'
import {UnitPrices} from '@/helpers/olympiaPrices'

export const slice = createSlice({
  name: 'prices',
  initialState,
  reducers: {
    SET_PRICES_LOADING: (state, {payload}: PayloadAction<boolean>) => {
      state.isLoading = payload
    },
    SET_PRICES: (
      state,
      {payload}: PayloadAction<{unitPrices: UnitPrices; fetchedAt: number}>
    ) => {
      state.unitPrices = payload.unitPrices
      state.fetchedAt = payload.fetchedAt
      state.isLoading = false
    },
    SET_DOMINION_RATE_LOADING: (state, {payload}: PayloadAction<boolean>) => {
      state.isDominionLoading = payload
    },
    SET_DOMINION_RATE: (
      state,
      {payload}: PayloadAction<{rate: number | null; fetchedAt: number}>
    ) => {
      state.reexPerDominion = payload.rate
      state.dominionFetchedAt = payload.rate === null ? null : payload.fetchedAt
      state.isDominionLoading = false
      state.isDominionAttempted = true
    },
  },
})

export const {
  SET_PRICES_LOADING,
  SET_PRICES,
  SET_DOMINION_RATE_LOADING,
  SET_DOMINION_RATE,
} = slice.actions

export default slice.reducer
